// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nodeInfo[data-v-b70e365a]{padding:10px 20px;margin-bottom:10px;background-color:var(--el-color-info-light-9)}.nodeInfo .etcd_error[data-v-b70e365a]{font-size:12px;padding:2px 10px;background-color:var(--el-color-warning);margin-top:10px;color:var(--el-color-white);margin-left:130px}", ""]);
// Exports
module.exports = exports;
